<a
  class="card w-full"
  [routerLink]="route()"
  [attr.role]="route() ? null : 'button'"
  [attr.tabindex]="route() ? null : 0"
  [style.border-radius]="borderRadius()"
  (click)="onCardClick()"
  (keydown)="onCardKeydown($event)"
>
  <div class="card__img w-full overflow-hidden" style="position: relative;">
    @if (card().src) {
      <!-- Skeleton Loader -->
      @if (!imageLoaded()) {
        <p-skeleton width="100%" height="100%" styleClass="absolute top-0 left-0" />
      }
      
      <img
        class="w-full h-full"
        [class.opacity-0]="!imageLoaded()"
        [class.animate-fadein]="imageLoaded()"
        [style.border-radius]="borderRadiusTop()"
        [ngSrc]="card().src"
        fill
        [alt]="card().title || 'Imagem do evento'"
        (load)="onImageLoad()"
      />
    } @else {
      <div 
        class="w-full h-full flex align-items-center justify-content-center bg-gray-200"
        [style.border-radius]="borderRadiusTop()">
        <i class="pi pi-image text-4xl text-gray-500"></i>
      </div>
    }
  </div>
  <div class="card__content w-full flex align-items-start">
    <div class="card__date flex justify-content-center">
      <div class="card__date-box flex flex-column justify-content-center align-items-center">
        <span class="font__day">{{ card().day }}</span>
        <span class="font__month">{{ card().month }}</span>
      </div>
    </div>
    <div class="card__texts flex flex-column">
      <div class="card__title w-full overflow-hidden">
        <span class="font__title">{{ card().title }}</span>
      </div>
      <div class="card__subtitle overflow-hidden">
        <span class="font__subtitle">{{ card().local }}</span>
      </div>
      <div class="card__state overflow-hidden">
        <div class="card__state-box flex align-items-center">
          <img ngSrc="assets/icons/map-pin.svg" height="14" width="14" alt="localização" />
          <span class="font__state">{{ card().state }}/{{ card().city }}</span>
        </div>
      </div>
    </div>
  </div>
</a>
